import React, { useContext } from 'react'

import { Chip, Icon } from '@clientbase/clientbase-library'
import { Box, Typography } from '@mui/material'

import { formatMoney } from 'utils'
import { formatDate } from 'utils/FormatDate'

import { NegativationContext } from '../../context'
import { renderTitle } from '../utils'
import { S } from './'
import { PaymentMethodEnum } from './BillingDetails.utils'

const BillingDetails: React.FC = () => {
  const { negativation, updateModalInvoice, updateModalDetail } =
    useContext(NegativationContext)

  return (
    <S.Wrapper>
      <Box>
        <Box alignItems="center" display="flex" gap={2}>
          {renderTitle('Detalhes da cobrança', 'event')}
          <Box
            display="flex"
            flexWrap="wrap"
            gap="8px"
            alignItems="center"
            onClick={() => {
              updateModalInvoice({
                open: true,
                uuid: negativation?.billing?.uuid
              })
              updateModalDetail((prevState) => ({ ...prevState, open: false }))
            }}
          >
            <Icon
              icon="open"
              width="21px"
              height="21px"
              ml="6px"
              sx={{ cursor: 'pointer', color: '#CBCBCB' }}
            />
          </Box>
        </Box>
        <S.ChargeSession>
          <Box
            display="flex"
            flexWrap="wrap"
            gap={1.25}
            alignItems="end"
            margin="10px 0px 10px 0px"
          >
            <Typography variant="smLight" color="#777777">
              Valor
            </Typography>
            <S.Separator sx={{ marginTop: '4px' }} />
            <Typography variant="smBold" display="flex" alignItems="center">
              {formatMoney(negativation?.billing?.amount_billed)}
            </Typography>
          </Box>
          <Box
            display="flex"
            gap={1.25}
            alignItems="end"
            margin="10px 0px 10px 0px"
          >
            <Typography variant="smLight" color="#777777">
              Vencimento
            </Typography>
            <S.Separator sx={{ marginTop: '4px' }} />
            <Typography variant="smBold" display="flex" alignItems="center">
              {formatDate(negativation?.billing?.due_date)}
            </Typography>
          </Box>
          <Box
            display="flex"
            gap={1.25}
            alignItems="end"
            margin="10px 0px 10px 0px"
          >
            <Typography variant="smLight" color="#777777">
              Data de expiração
            </Typography>
            <S.Separator sx={{ marginTop: '4px' }} />
            <Typography variant="smBold" display="flex" alignItems="center">
              {formatDate(negativation?.billing?.expiration_date)}
            </Typography>
          </Box>
          {/* TODO: Quando tiver API habilitar */}
          {/* {DiscountPolicyEnum[invoice?.discountPolicy] === 'Sim' &&
          invoice?.discounts.length > 0 ? (
            invoice?.discounts.map((discount, index) => (
              <Box
                display="flex"
                gap={1.25}
                alignItems="end"
                margin="10px 0px 10px 0px"
                key={index}
              >
                <Typography variant="smLight" color="#777777">
                  Desconto {index + 1}:
                </Typography>
                <S.Separator sx={{ marginTop: '4px' }} />
                <Typography variant="smBold" display="flex" alignItems="center">
                  <Box key={index}>
                    {formatMoney(Number(discount.amount))} até{' '}
                    {moment(stringToDate(invoice?.dueDate as string))
                      .subtract(discount.days, 'days')
                      .format('DD/MM/YYYY')}
                  </Box>
                </Typography>
              </Box>
            ))
          ) : (
            <Box
              display="flex"
              gap={1.25}
              alignItems="end"
              margin="10px 0px 10px 0px"
            >
              <Typography variant="smLight" color="#777777">
                Desconto:
              </Typography>
              <S.Separator sx={{ marginTop: '4px' }} />
              <Typography variant="smBold">Não</Typography>
            </Box>
          )} */}
          {/* <ChargeFineAndInterest
            interestFee={invoice?.interestFee}
            interestFine={invoice?.interestFine}
            interestPolicy={invoice?.interestPolicy}
          /> */}

          <Typography variant="smLight" color="#777777">
            Formas de pagamento
          </Typography>
          <Box
            display="flex"
            flexWrap="wrap"
            gap="8px"
            margin="10px 0px 10px 0px"
          >
            {negativation?.billing?.payment_type?.split(';')?.map(
              (item) =>
                item && (
                  <Chip
                    sx={(theme: any) => ({
                      background: theme.palette.neutral[400]
                    })}
                    variant="payment"
                    key={String(item)}
                    label={PaymentMethodEnum[String(item)].toUpperCase()}
                  />
                )
            )}
          </Box>
          {negativation?.billing?.description && (
            <Box
              margin="10px 0px 10px 0px"
              display="flex"
              flexDirection="column"
              gap={1}
            >
              <Typography variant="smLight" color="#777777">
                Descrição
              </Typography>
              <Typography>{negativation?.billing?.description}</Typography>
            </Box>
          )}
        </S.ChargeSession>
      </Box>
    </S.Wrapper>
  )
}

export default BillingDetails
